import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { Divider, Stack, SxProps, Theme } from '@mui/material';
import React from 'react';

import { SUPPORT_EMAIL_MAILTO } from '../../../constants/contactConstants';
import { AnalyticsEvents } from '../../../enums/AnalyticsEvents';
import { useAnalytics } from '../../../hooks/useAnalytics';
import useAuth from '../../../hooks/useAuth';
import { useTranslation } from '../../../hooks/useTranslation';
import { canPerformAction, PERMISSIONS } from '../../../utils/permissions';
import SidebarInfoLink from '../SidebarInfoLink/SidebarInfoLink';

interface BillingSupportLinksProps {
  sx?: SxProps<Theme>;
}

const BillingSupportLinks: React.FC<BillingSupportLinksProps> = ({ sx }) => {
  const { t } = useTranslation();
  const { currentUser } = useAuth();
  const { track } = useAnalytics();

  const canManageBilling = Boolean(
    currentUser && canPerformAction(currentUser, PERMISSIONS.MANAGE_BILLING)
  );

  return (
    <Stack
      divider={<Divider sx={{ borderColor: 'rgba(15, 23, 42, 0.08)' }} />}
      spacing={1.5}
      sx={sx}
    >
      {canManageBilling && (
        <SidebarInfoLink
          icon={<CreditCardOutlinedIcon fontSize="small" />}
          title={t('Billing')}
          subtitle={t('simplify charges')}
          to="/billing"
          onClick={() => {
            track(AnalyticsEvents.BILLING_MANAGEMENT_BUTTON_CLICKED);
          }}
        />
      )}
      <SidebarInfoLink
        icon={<MailOutlineIcon fontSize="small" />}
        title={t('Need a help?')}
        subtitle={t('send us an email')}
        href={SUPPORT_EMAIL_MAILTO}
        target="_blank"
        rel="noreferrer"
      />
    </Stack>
  );
};

export default BillingSupportLinks;
